import { render, staticRenderFns } from "./TransportView.vue?vue&type=template&id=4bee3874"
import script from "./TransportView.vue?vue&type=script&lang=ts"
export * from "./TransportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports